// extracted by mini-css-extract-plugin
export default {"row":"Row_row__Vi0g3","cell":"Row_cell__9+HXw","cell-clickable":"Row_cell-clickable__PLNxg","badge":"Row_badge__uwgcv"};